// Display-side clip for Coach drilling. The Coach loops a small bar *window*; the
// highway and staff otherwise render the whole piece, so notes beyond the window fall
// toward you even though the loop will reset before you reach them — startling ("the
// passage restarts abruptly"). Showing only the window's notes makes the loop legible.
// When no window is set (wait/scored), all notes show. The filtered slice is memoized on
// (notes identity, window) so the per-frame render loop — which asks twice, for the staff
// and the falling notes — reuses one array instead of allocating two each frame.
import type { NoteEvent } from "../types";

let memo: {
  notes: readonly NoteEvent[];
  start: number | null;
  end: number | null;
  out: readonly NoteEvent[];
} | null = null;

export function drillWindowNotes(
  notes: readonly NoteEvent[],
  windowStart: number | null,
  windowEnd: number | null,
): readonly NoteEvent[] {
  if (windowStart === null || windowEnd === null) return notes;
  const m = memo;
  if (m && m.notes === notes && m.start === windowStart && m.end === windowEnd) return m.out;
  const out = notes.filter((n) => n.onset >= windowStart && n.onset < windowEnd);
  memo = { notes, start: windowStart, end: windowEnd, out };
  return out;
}
